import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-black text-white py-10 sm:py-12">
      <div className="mx-auto max-w-[1200px] px-[5%] lg:px-[5%]">
        <div className="grid md:grid-cols-3 gap-8 sm:gap-12">
          {/* Address */}
          <div className="space-y-3 sm:space-y-4">
            <h3 className="text-[17px] sm:text-xl font-semibold mb-4 sm:mb-6">
              Address
            </h3>
            <div className="flex items-start gap-3">
              <MapPin className="h-4 w-4 sm:h-5 sm:w-5 mt-0.5 flex-shrink-0" />
              <div className="text-gray-300 text-[13px] sm:text-[15px] leading-relaxed">
                1625 Sonny Schulz Blv, Suite A
                <br />
                Stevensville, Maryland 21666
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-3 sm:space-y-4">
            <h3 className="text-[17px] sm:text-xl font-semibold mb-4 sm:mb-6">
              Contact
            </h3>
            <div className="space-y-2 sm:space-y-3">
              <div className="flex items-center gap-3">
                <Phone className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0" />
                <a
                  href="tel:+14106041400"
                  className="text-gray-300 text-[13px] sm:text-[15px] hover:text-white transition-colors"
                >
                  +1 (410) 604-1400
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0" />
                <a
                  href="mailto:info@michmfg.com"
                  className="text-gray-300 text-[13px] sm:text-[15px] hover:text-white transition-colors"
                >
                  info@michmfg.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <svg
                  className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
                <a
                  href="https://www.linkedin.com/company/michigan-manufacturing-international/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 text-[13px] sm:text-[15px] hover:text-white transition-colors"
                >
                  LinkedIn
                </a>
              </div>
            </div>
          </div>

          {/* Manufacturing Locations */}
          <div className="space-y-3 sm:space-y-4">
            <h3 className="text-[17px] sm:text-xl font-semibold mb-4 sm:mb-6">
              Our Manufacturing Locations
            </h3>
            <div className="space-y-2 sm:space-y-3 text-gray-300 text-[13px] sm:text-[15px]">
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 sm:h-5 sm:w-5 mt-0.5 flex-shrink-0" />
                <span>Chennai - WTEC Pvt Ltd</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 sm:h-5 sm:w-5 mt-0.5 flex-shrink-0" />
                <span>Coimbatore - MCAF Pvt Ltd</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 sm:h-5 sm:w-5 mt-0.5 flex-shrink-0" />
                <span>Hosur - MMI Pvt Ltd</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 sm:h-5 sm:w-5 mt-0.5 flex-shrink-0" />
                <span>Maryland - MMI Headquarters</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}